var ConfirmationView = (function (BaseView, globalUrls) {

    return BaseView.extend({
        displayRoutes: ['checkout.success'],

        el: '@confirmation',

        initialize: function (opts) {
            this._pixel = opts.pixel;
            this._paymentInfoPixel = opts.paymentInfoPixel;
            this._currentMethod = opts.currentMethod;
            this._order = opts.order;
            this.listenTo(this.model, 'change', _.bind(function () {
                this.display('checkout.success');
            }, this));
        },

        beforeShow: function () {
            this.render();

            !function (_this, app, CheckoutSettings) {
                var basketSettings = CheckoutSettings.getBasketSettings();

                if (!(basketSettings && basketSettings.RoktEnabled)) {
                    return;
                }

                var _currentAddress = _this._order.get('Delivery').get('Current'),
                    _name = (_currentAddress.get('Name') || '').split(' '),
                    lastName = _name.pop(),
                    firstName = _name.join(' '),
                    postcode = _currentAddress.get('Postcode') || '',
                    email = _this.model.get('un'),
                    id = basketSettings.RoktID;

                if (_name === '' && postcode === '') {
                    return;
                }

                _this._callROKT(id, firstName, lastName, email, postcode);
            }(this, app, CheckoutSettings);
        },

        afterShow: function () {
            this.setBackCallback();
            this._paymentInfoPixel && this._paymentInfoPixel.trigger(this.model.get('order'), this._currentMethod);
            this._pixel.confirmation(this.model, this._order.get('Summary'));
        },

        render: function () {
            var orderInfoResult = this.model.get('orderInfoResult');
            var _City = '';
            if ( orderInfoResult.DeliveryAddress.City !== null)
                _City +=  orderInfoResult.DeliveryAddress.City;

            if ( orderInfoResult.DeliveryAddress.Suburb !== null)
                _City += ' ' +  orderInfoResult.DeliveryAddress.Suburb;

            _City = _City.trim();


            var voucher = this.model.get('voucher');
            this.$el.html($.tmpl('bt-checkout-confirmation-ourpay', $.extend(this.model.toJSON(), {
                // TBD: This variables aren't used in the template
                linkOnMyAccount: globalUrls.shop,
                estimatedDeliveryDateFrom: orderInfoResult.DeliveryDateFrom && orderInfoResult.DeliveryDateFrom.fromMStoOzSaleDateShort(),
                estimatedDeliveryDateTo: orderInfoResult.DeliveryDateTo && orderInfoResult.DeliveryDateTo.fromMStoOzSaleDateShort(),
                estimatedDeliveryText: orderInfoResult.EstimatedDeliveryText,
                email: orderInfoResult.Email,
                phone: orderInfoResult.DeliveryAddress.Phone,
                firstname: orderInfoResult.CustomerFirstName,
                lastname: orderInfoResult.CustomerLastName,
                street: orderInfoResult.DeliveryAddress.AddressLines,
                city: _City,
                region: orderInfoResult.DeliveryAddress.State,
                postcode: orderInfoResult.DeliveryAddress.Postcode,
                country: orderInfoResult.CustomerCountryName,
            })));

            //if address is not pickup point
            if (!this.model.get('addressAdditionalData') || this.model.get('addressAdditionalData').length === 0) {
                var link = '/my-account/orders/' + this.model.get('invoiceNo') + '/change-address?invoice_no=' + orderInfoResult.InvoiceNo;

                window.app &&
                    app.event &&
                    app.event.stripeFailed &&
                    app.event.confirmationInfo(this.model.get('addressString') || "");

                this.$('@postcheckoutAddressText').html($.tmpl('bt-checkout-confirm-address',
                    {
                        Address: this.model.get('addressString').split(','),
                        ChangeAddressLink: link
                    }));
            }

            if (window.BestSellers) {
                BestSellers.init(this.$('@bestSellers'), false);
            }

            if (voucher) {
                this.$('@giftVoucher').html($.tmpl('bt-checkout-gift-voucher',
                    {
                        Discount: window.toMoney(voucher.Amount, GlobalSettings.CurrencySign).replace(/\.00$/, ''),
                        MinSpend: window.toMoney(voucher.MinSpend, GlobalSettings.CurrencySign).replace(/\.00$/, ''),
                        ExpiryDate: voucher.ExpiryDate,
                        MyVouchersLink: CheckoutSettings.getBasketSettings().MyVouchersLink
                    }));
            }

            var plannedTransactions = this.model.get('plannedTransactions');
            plannedTransactions &&
                this.$('@confirmationPlannedTransactions').html(new MyPayTransactionsView({ collection: plannedTransactions, type: 'medium' })._show()) ||
                this.$('@plannedTransactionsWrapper').hide();
        },

        _callROKT: function (id, firstName, lastName, email, postcode) {
            if (!id) {
                return;
            }

            var _bhid = id + '-b';

            this.$el.append($('<div />').attr('id', _bhid));

            !function () {
                var rokt = window._ROKT = window._ROKT || [];

                // Recommended
                rokt.push(['email', email]);

                // Consumer
                rokt.push(['firstname', firstName]);
                rokt.push(['lastname', lastName]);

                // Address
                rokt.push(['zipcode', postcode]);
                rokt.push(['country', GlobalSettings.Iso]);


                var js = document.createElement('SCRIPT');
                js.type = 'text/JavaScript';
                js.async = true;
                js.src = location.protocol + '//apps.rokt.com/?id=' + id + '&bhid=' + _bhid + '&v=' + Math.floor(Math.random() * 999).toString();
                var p = document.getElementsByTagName('script')[0];
                p.parentNode.insertBefore(js, p);
            }();
        }
    });
})(BaseView, globalUrls);